import type { Maybe } from '@adornis/base/utilTypes.js';
import type { ContractSupplementApplyHistory } from '../entities/AppliedContract.js';

export const getHistoryForPath = (history: Maybe<ContractSupplementApplyHistory>, path: string) => {
  const entry = history?.paths?.find(e => e.path?.includes(path));
  if (!entry) return undefined;
  return entry;
};
